import { Input, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

interface CustomCodeFieldProps {
  /** K-6 — `content.customcode` yetkisi (useCan(PERMISSIONS.CONTENT_CUSTOM_CODE)). */
  canEdit: boolean;
  value?: string | null;
  onChange?: (value: string | null) => void;
  rows?: number;
}

/**
 * CustomCode (ham HTML/JS/JSON-LD) alanı — sanitize edilmeyen tek zengin alan.
 *
 * BE guard'ı (K-6) alan DEĞİŞİYORSA `content.customcode` ister; mevcut değer
 * dokunulmadan kalırsa yetki gerekmez. Bu yüzden yetkisiz kullanıcıya alan
 * salt-okunur gösterilir (değer görünür, form gönderiminde aynen korunur) ve
 * tooltip + görünür ipucu ile gereken yetki açıklanır.
 *
 * Page/Article/Campaign editörlerinde `FormField` içinde kullanılır; boşaltılan
 * değer `null`'a normalize edilir (BE sözleşmesi `string | null`).
 */
export function CustomCodeField({ canEdit, value, onChange, rows = 3 }: CustomCodeFieldProps) {
  const { t } = useTranslation('common');

  const textArea = (
    <Input.TextArea
      rows={rows}
      maxLength={4000}
      showCount={canEdit}
      disabled={!canEdit}
      value={value ?? ''}
      onChange={(e) => onChange?.(e.target.value || null)}
    />
  );

  if (canEdit) return textArea;

  return (
    <Tooltip title={t('customCode.noPermission')}>
      {/* Disabled input'lar hover event üretmez — tooltip sarmalayıcıya bağlanır. */}
      <div>
        {textArea}
        <div style={{ marginTop: 4, fontSize: 12, color: 'var(--ds-text-tertiary, #999)' }}>
          {t('customCode.noPermission')}
        </div>
      </div>
    </Tooltip>
  );
}
